import React, { useState} from "react";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import { Container, Row, Col, Card, CardBody, CardDeck, CardFooter, Button } from "reactstrap";
import ProductSearch from "./ProductSearch";
import { useHistory } from "react-router-dom";
import ExportBMECatModal from "../../components/ETIM/ExportBMECatModal";

const Home = () => {
  const history = useHistory();
  const [BMECatModalOpen, setBMECatModalOpen] = useState(false);
  const toggleBMECatModal = () => setBMECatModalOpen(!BMECatModalOpen);
  const handleSeriesSelect = async (series) => {
    const classEtim = series.classETIM;
    let nextPath = classEtim ? `/series/etim/edit/${series.id}/${classEtim}/characteristics` : `/series/etim/edit/${series.id}`;

    history.push({
      pathname: nextPath,
      state: { classEtim },
    });
  };

  const handleExportBmeCat = () => {
    setBMECatModalOpen(true);
  };

  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="etim.title" defaultMessage="Edit an existing product" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <h3 className="card-title">
                      <FormattedMessage id="etim.select_product" defaultMessage="Select a product." />
                    </h3>
                    <p>
                      <FormattedMessage id="etim.description" defaultMessage="Please use the options below to search and select a product."></FormattedMessage>
                    </p>
                  </Col>
                </Row>
                <row>
                  <Col className="mt-3">
                    <ProductSearch onSeriesSelect={handleSeriesSelect}></ProductSearch>
                  </Col>
                </row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <CardDeck>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <h3 className="card-title">
                        <FormattedMessage id="etim.select_option" defaultMessage="Select an option." />
                      </h3>
                      <p>
                        <FormattedMessage id="etim.export_bme_description" defaultMessage="Please use the option below to export BMECAT"></FormattedMessage>
                      </p>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Button onClick={handleExportBmeCat} className="btn btn-outline-dark">
                    <FormattedMessage id="etim.export_bmecat" defaultMessage="Export BMECAT" />
                  </Button>
                </CardFooter>
              </Card>
            </CardDeck>
          </Col>
        </Row>
      </Container>
      <ExportBMECatModal isOpen={BMECatModalOpen} toggle={toggleBMECatModal} />
    </>
  );
};

export default Home;
